var map = {
	"./bg_v2.mp4": 4234,
	"./loader-150.webp": 8809,
	"./mosharust.png": 2786,
	"./no-banner-min.png": 3497,
	"./photo.webp": 1503,
	"./rust-marque.svg": 4990,
	"./store.webp": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;